import { render, staticRenderFns } from "./CertificadoForm.vue?vue&type=template&id=5034a11a&scoped=true&"
import script from "./CertificadoForm.vue?vue&type=script&lang=js&"
export * from "./CertificadoForm.vue?vue&type=script&lang=js&"
import style0 from "./CertificadoForm.vue?vue&type=style&index=0&id=5034a11a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5034a11a",
  null
  
)

export default component.exports